const validUriAttrs: Array<string> = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];
const ARIA_ATTRIBUTE_PATTERN: RegExp = /^aria-[\w-]*$/i;
const DATA_ATTRIBUTE_PATTERN: RegExp = /^data-[\w-]*$/i;
const DefaultWhitelist = {
  '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN, DATA_ATTRIBUTE_PATTERN],
  'a': ['target', 'href', 'title', 'rel'],
  'area': [],
  'b': [],
  'br': [],
  'col': [],
  'code': [],
  'div': [],
  'em': [],
  'hr': [],
  'h1': [],
  'h2': [],
  'h3': [],
  'h4': [],
  'h5': [],
  'h6': [],
  'i': [],
  'img': ['src', 'srcset', 'alt', 'title', 'width', 'height'],
  'li': [],
  'ol': [],
  'p': [],
  'pre': [],
  's': [],
  'small': [],
  'span': [],
  'sub': [],
  'sup': [],
  'strong': [],
  'u': [],
  'ul': [],
};
export const SAFE_URL_PATTERN: RegExp = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
const DATA_URL_PATTERN: RegExp = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
function allowedAttribute(t, e) {
  let i = t.nodeName.toLowerCase();
  if (-1 !== e.indexOf(i)) return -1 === validUriAttrs.indexOf(i) || Boolean(SAFE_URL_PATTERN.test(t.nodeValue) || DATA_URL_PATTERN.test(t.nodeValue));
  let o = e.filter(t => t instanceof RegExp);
  for (let n = 0, s = o.length; n < s; n++) if (o[n].test(i)) return !0;
  return !1;
}
function safeHTML(t, e, i) {
  if (0 === t?.length) return t;
  if (i && 'function' == typeof i) return i(t);
  let o = new DOMParser(),
    n = o.parseFromString(t, 'text/html'),
    s = Object.keys(e),
    l = [].slice.call(n.body.querySelectorAll('*'));
  for (let r = 0, a = l.length; r < a; r++) {
    let p = l[r],
      h = p.nodeName.toLowerCase();
    if (-1 === s.indexOf(p.nodeName.toLowerCase())) {
      p.parentNode.removeChild(p);
      continue;
    }
    let c = [].slice.call(p.attributes),
      f = [].concat(e['*'] || [], e[h] || []);
    c.forEach(t => {
      allowedAttribute(t, f) || p.removeAttribute(t.nodeName);
    });
  }
  return n.body.innerHTML;
}
export const htmlSanitizer = (data: string | HTMLElement | null) => {
  return safeHTML(data, DefaultWhitelist, null);
};
